import {ApiDateRange} from '../../../date-range-picker/models/types';
import {CohortSegment} from '../../../query-block/segment-menu/types';
import {FilterValue, LogicalOperator, ResourceType} from '../types';

export type SerializedFilterOperand = string | boolean | number | ApiDateRange | CohortSegment;
export type SerializedFilterValue = SerializedFilterOperand | SerializedFilterOperand[];

export enum SerializedResourceType {
  Literal = `literal`,
}

export enum ArithmeticOperator {
  Datetime = `$datetime`,
  Defined = `defined`,
  Equals = `==`,
  GreaterThan = `>`,
  GreaterThanEquals = `>=`,
  In = `in`,
  LessThan = `<`,
  LessThanEquals = `<=`,
  NotDefined = `not defined`,
  NotEquals = `!=`,
  NotIn = `not in`,
}

export enum TypeCastOperator {
  Boolean = `boolean`,
  Datetime = `datetime`,
  List = `list`,
  Number = `number`,
  String = `string`,
}

export type Operator = ArithmeticOperator | LogicalOperator | TypeCastOperator;

export interface Operand {
  property: ResourceType;
  value: FilterValue;
  data_group_id?: string;
}

export interface SerializedOperand {
  property: ResourceType | SerializedResourceType;
  value: SerializedFilterValue;
  data_group_id?: string;
}

export interface Expression {
  operator: Operator;
  children: Array<Expression | Operand>;
}
